
import React from 'react';

interface TourNoteProps {
  content: string;
}

const TourNote: React.FC<TourNoteProps> = ({ content }) => {
  return (
    <div className="max-w-2xl mx-auto mb-8">
      <div className="bg-[#F5EDE0] p-4 rounded-lg border border-[#C58B65]/20">
        <p className="text-[#3E2723] font-medium text-center">
          <strong>Tour Note:</strong> {content}
        </p>
      </div>
    </div>
  );
};

export default TourNote;
